<template>
  <div class="advantage">
    <div class="info advantageInfo">
      <div class="advantage-head flexBetween">
        <div class="indexTitle">
          <p class="flexItems"><span></span>优势</p>
          <p>Advantage</p>
        </div>
        <div class="advantage-nav">
          <ul class="flex">
            <li
              class="flexItems"
              :class="{ advantageLi: num == 0 }"
              @click="num = 0"
            >
              平台优势
            </li>
            <li
              class="flexItems"
              :class="{ advantageLi: num == 1 }"
              @click="num = 1"
            >
              技术优势
            </li>
          </ul>
        </div>
      </div>
      <div class="advantage-container">
        <div class="advantage-item" v-show="num == 0">
          <div class="advantage-item-title">
            让行业痛点成为<span>过去式</span>
          </div>
          <div class="advantage-item-box flex">
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">交易安全</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>无船承运人资质+网络货运资质</li>
                  <li>网络信息安全等保三级资质</li>
                  <li>网络增值服务ICP和EDI证书</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">高效便捷</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>一键线上交易 智能匹配车船货</li>
                  <li>运费在线支付 零手续费</li>
                  <li>无纸化操作 数据保留云端 随时查看</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">物流管理</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>货流实时监控 轨迹数据真实</li>
                  <li>跟单审核机制 运单风险自动预警</li>
                  <li>线上资源优化配置 线下高效运输</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">税务闭环</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>平台开放接口给税务局</li>
                  <li>五流合一 真实数据源</li>
                  <li>保障税务链条完整合法</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="advantage-item" v-show="num == 1">
          <div class="advantage-item-title">
            让科技为您<span>保驾护航</span>
          </div>
          <div class="advantage-item-box flex">
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">
                高效智能匹配算法
              </div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>就近派单 减少空载 高效装卸货</li>
                  <li>行业大数据精准分析 根据运费趋势</li>
                  <li>生成平台高效的全域运力调动算法</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">
                完整运输服务体系
              </div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>陆运与水运结合 提供水陆多式联运服务</li>
                  <li>提高运输管理水平 实现“门到门”运输</li>
                  <li>合理规划路线 降低运输成本 增加经济效益</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="phone-advantage">
      <div class="indexTitle">
        <p class="flexItems"><span></span>优势</p>
        <p>Advantage</p>
      </div>
      <div class="advantage-nav">
        <ul class="flex">
          <li
            class="flexItems"
            :class="{ advantageLi: num == 0 }"
            @click="num = 0"
          >
            平台优势
          </li>
          <li
            class="flexItems"
            :class="{ advantageLi: num == 1 }"
            @click="num = 1"
          >
            技术优势
          </li>
        </ul>
      </div>
      <div class="phone-advantage-swiper">
        <div class="phone-advantage-swiper-box">
          <div class="phone-advantage-swiper-item" v-show="num == 0">
            <div class="advantage-item-title">
              让行业痛点成为<span>过去式</span>
            </div>
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide>
                <div class="advantage-item-box-li">
                  <div class="advantage-item-box-li-title flexCenter">
                    交易安全
                  </div>
                  <div class="advantage-item-box-li-text">
                    <ul>
                      <li>无船承运人资质+网络货运资质</li>
                      <li>网络信息安全等保三级资质</li>
                      <li>网络增值服务ICP和EDI证书</li>
                    </ul>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage-item-box-li">
                  <div class="advantage-item-box-li-title flexCenter">
                    高效便捷
                  </div>
                  <div class="advantage-item-box-li-text">
                    <ul>
                      <li>一键线上交易 智能匹配车船货</li>
                      <li>运费在线支付 零手续费</li>
                      <li>无纸化操作 数据保留云端 随时查看</li>
                    </ul>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage-item-box-li">
                  <div class="advantage-item-box-li-title flexCenter">
                    物流管理
                  </div>
                  <div class="advantage-item-box-li-text">
                    <ul>
                      <li>货流实时监控 轨迹数据真实</li>
                      <li>跟单审核机制 运单风险自动预警</li>
                      <li>线上资源优化配置 线下高效运输</li>
                    </ul>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage-item-box-li">
                  <div class="advantage-item-box-li-title flexCenter">
                    税务闭环
                  </div>
                  <div class="advantage-item-box-li-text">
                    <ul>
                      <li>平台开放接口给税务局</li>
                      <li>五流合一 真实数据源</li>
                      <li>保障税务链条完整合法</li>
                    </ul>
                  </div>
                </div>
              </swiper-slide>
              <div
                class="swiper-pagination phone-service-page"
                slot="pagination"
              ></div>
            </swiper>
          </div>
          <div class="phone-advantage-swiper-item" v-show="num == 1">
            <div class="advantage-item-title">
              让科技为您<span>保驾护航</span>
            </div>
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide>
                <div class="advantage-item-box-li">
                  <div class="advantage-item-box-li-title flexCenter">
                    高效智能匹配算法
                  </div>
                  <div class="advantage-item-box-li-text">
                    <ul>
                      <li>就近派单 减少空载 高效装卸货</li>
                      <li>行业大数据精准分析 根据运费趋势</li>
                      <li>生成平台高效的全域运力调动算法</li>
                    </ul>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage-item-box-li">
                  <div class="advantage-item-box-li-title flexCenter">
                    完整运输服务体系
                  </div>
                  <div class="advantage-item-box-li-text">
                    <ul>
                      <li>陆运与水运结合 提供水陆多式联运服务</li>
                      <li>提高运输管理水平 实现“门到门”运输</li>
                      <li>合理规划路线 降低运输成本 增加经济效益</li>
                    </ul>
                  </div>
                </div>
              </swiper-slide>
              <div
                class="swiper-pagination phone-service-page"
                slot="pagination"
              ></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <span class="zmldown2"></span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: 0,
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};
</script>
<style scoped="scoped">
/* 优势 */
.advantage {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}
.advantageInfo {
  padding-top: 120px;
}
.advantage-nav ul {
  height: 100%;
  align-items: center;
}
.advantage-nav ul li {
  height: 100%;
  margin-left: 80px;
  font-size: 18px;
  color: #343434;
  white-space: nowrap;
  /* font-weight: bold; */
  position: relative;
  cursor: pointer;
}
.advantageLi::before {
  position: absolute;
  content: "";
  width: 32px;
  height: 3px;
  background-color: #127bfd;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.advantage-item-box {
  justify-content: center;
}

@media only screen and (max-width: 1400px) {
  .advantage-item-title {
    padding: 30px;
    font-size: 30px;
  }
  .advantage-item-box-li-text {
    padding: 10px;
  }
}
@media only screen and (max-width: 1600px) {
  .advantage-item {
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .advantage-item-box {
    align-items: auto;
    flex: 1;
    padding-bottom: 60px;
    justify-content: center;
  }
  .advantage-item-box-li {
    width: 25%;
    height: auto;
    min-height: 350px;
  }
  .advantage-item-box-li-text ul li {
    /* margin-bottom: 10px; */
    /* font-size: 14px; */
  }
  .advantageInfo {
    display: flex;
    flex-flow: column;
  }
  .advantage-container {
    flex: 1;
  }
  .advantage-item-title {
    padding: 30px;
    font-size: 40px;
  }
  .advantage-item-box-li-text {
    padding: 20px;
  }
}

@media only screen and (max-width: 750px) {
  .advantage {
    background-color: #efefef;
  }
  .advantageInfo {
    padding-top: 0;
    display: none;
  }
  .phone-advantage {
    position: relative;
    z-index: 990;
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .phone-advantage .advantage-nav {
    padding-top: 18px;
    position: relative;
    z-index: 991;
  }
  .phone-advantage .advantage-nav ul {
    justify-content: center;
  }
  .phone-advantage .advantage-nav ul li {
    margin-left: 0px;
    font-size: 14px;
    font-weight: bold;
    line-height: 30px;
    margin: 0 10px;
  }
  .advantage-item-title {
    padding: 40px 70px 10px;
    font-size: 8vw;
    font-weight: 700;
  }
  .advantage-item-box-li {
    width: 220px;
    /* height: 320px; */
    min-height: 320px;
  }
  .swiper-container {
    overflow: inherit;
  }
  .swiper-slide {
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .advantage-item-box-li-title {
    height: 46px;
    font-size: 18px;
    /* font-weight: bold; */
  }
  .advantage-item-box-li-text {
    padding: 20px;
  }
  .advantage-item-box-li-text ul li {
    font-size: 14px;
    margin-left: 12px;
    line-height: 20px;
    margin-bottom: 15px;
  }
  .swiper-pagination {
    bottom: -30px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .phone-service-page >>> .swiper-pagination-bullet-active {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: url(../../static/img/active-point.png) no-repeat center;
    background-size: cover;
  }
  .phone-advantage-swiper {
    flex: 1;
  }
  .phone-advantage-swiper-box {
    position: relative;
    top: 50%;
    transform: translateY(-60%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index_advantage.vue